import { ApiService, StateService } from '@brightsolutionsgmbh/client-core';
import settings from '../utils/settings';

ApiService.init(settings.getApiServiceConfig());
StateService.init();

export const apiService = ApiService;
export const stateService = StateService;
